module.exports = __webpack_public_path__ + "static/img/pic16.1.c1ad41b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic16.1.png
// module id = ZaHp
// module chunks = 0